var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.sendStatus == "init"
        ? _c(
            "b-form",
            { on: { submit: _vm.onSubmit } },
            [
              _c("form-contact", {
                attrs: { contact: _vm.contact },
                on: {
                  "update:contact": function ($event) {
                    _vm.contact = $event
                  },
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "form__group field" }, [
                _c(
                  "label",
                  { staticClass: "form__label", attrs: { for: "products" } },
                  [_vm._v("Betreffendes Produkt")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("b-form-select", {
                      staticClass: "form__field",
                      attrs: {
                        id: "products",
                        required: "",
                        options: _vm.products,
                      },
                      model: {
                        value: _vm.selectedProduct,
                        callback: function ($$v) {
                          _vm.selectedProduct = $$v
                        },
                        expression: "selectedProduct",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form__group field" }, [
                _c(
                  "label",
                  { staticClass: "form__label", attrs: { for: "body" } },
                  [_vm._v("Ihre Anfrage")]
                ),
                _vm._v(" "),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.body,
                      expression: "body",
                    },
                  ],
                  staticClass: "form__field",
                  attrs: {
                    cols: "",
                    rows: "7",
                    placeholder: "Anfrage",
                    name: "body",
                    id: "body",
                  },
                  domProps: { value: _vm.body },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.body = $event.target.value
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("privacy-policy", {
                attrs: {
                  ppAccepted: _vm.ppAccepted,
                  pnUrl: _vm.privacyNoticeUrl,
                },
                on: {
                  "update:ppAccepted": function ($event) {
                    _vm.ppAccepted = $event
                  },
                  "update:pp-accepted": function ($event) {
                    _vm.ppAccepted = $event
                  },
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "form__group field text-right" }, [
                _c("input", {
                  staticClass: "btn btn-outline-primary",
                  attrs: {
                    type: "submit",
                    value: "Absenden",
                    disabled: !_vm.ppAccepted,
                  },
                }),
              ]),
            ],
            1
          )
        : _vm.sendStatus == "pending"
        ? _c("b-alert", { attrs: { show: "" } }, [
            _c("div", [
              _c("i", { staticClass: "fa fa-spin fa-spinner" }),
              _vm._v("\n      Wird gesendet\n    "),
            ]),
          ])
        : _vm.sendStatus == "success" && !("error" in _vm.response)
        ? _c("b-alert", { attrs: { show: "", variant: "success" } }, [
            _c("div", [
              _c("i", { staticClass: "fa fa-warning" }),
              _vm._v("\n      " + _vm._s(_vm.response.data.message) + "\n    "),
            ]),
          ])
        : "error" in _vm.response
        ? _c("b-alert", { attrs: { show: "", variant: "danger" } }, [
            _c("div", [
              _c("i", { staticClass: "fa fa-warning" }),
              _vm._v(
                "\n      " + _vm._s(_vm.response.error.message) + "\n    "
              ),
            ]),
          ])
        : _c("b-alert", { attrs: { show: "", variant: "danger" } }, [
            _c("div", [
              _c("i", { staticClass: "fa fa-warning" }),
              _vm._v("\n      Fehler beim Senden\n    "),
            ]),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }